"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.momentConvertTime = exports.replaceMiddle = exports.convertMoneyStringToFloat = exports.formatNumber = void 0;
const moment_1 = __importDefault(require("moment"));
const formatNumber = (number) => {
    let formatted = number
        ? number
            .toString()
            .replace(/\s?/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            .trim()
        : "0";
    return formatted;
};
exports.formatNumber = formatNumber;
const convertMoneyStringToFloat = (moneyAmount) => {
    if (!moneyAmount) {
        return 0;
    }
    else if (typeof moneyAmount === "number") {
        return moneyAmount;
    }
    return Number(moneyAmount.replace(/[^0-9.]+/g, ""));
};
exports.convertMoneyStringToFloat = convertMoneyStringToFloat;
function replaceMiddle(string, n) {
    var rest = string.length - n;
    return (string.slice(0, Math.ceil(rest / 2) + 1) +
        ".".repeat(n / 6) +
        string.slice(-Math.floor(rest / 2) + 1));
}
exports.replaceMiddle = replaceMiddle;
function momentConvertTime(timestamp) {
    // '+' = unary operator - it converts string to number (alternative to parseFloat())
    return (0, moment_1.default)(+timestamp).format("HH:mm Z on DD MMM YYYY");
}
exports.momentConvertTime = momentConvertTime;
//# sourceMappingURL=formatUtils.js.map